import { Outlet, Navigate } from "react-router-dom";
// import your auth context or logic here

const ProtectedRoute = () => {
  // Replace this with your actual auth logic
  const isAuthenticated = localStorage.getItem("accessToken");
  if (!isAuthenticated) {
    return <Navigate to="/pagenotfound" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
